import Faq from './Faq';
import FaqPage from './FaqPage';

export { Faq, FaqPage };
